import * as React from 'react';
import Hotkeys, { IReactHotkeysProps, OnKeyFun } from 'react-hot-keys';
import { track } from '../../tracking';

interface Props extends IReactHotkeysProps {
    onKeyDown: OnKeyFun;
    keyName: string;
}

export const WithKeyboardPressHandling: React.FC<Props> = ({
    onKeyDown,
    keyName,
    children,
    ...restProps
}) => {
    const handleKeyDownEvent: OnKeyFun = (keyName, e, handle) => {
        e.stopPropagation();
        e.preventDefault();
        onKeyDown(keyName, e, handle);
        track('KEYBOARD_OVERRIDE', { keyName: keyName });
    };
    return (
        <Hotkeys keyName={keyName} onKeyDown={handleKeyDownEvent} {...restProps}>
            {children}
        </Hotkeys>
    );
};
